import {StyleParamType, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {Alignment, ImageSize} from '../../../../../types/createStylesParams'
import {
  ALIGNMENT_DESCRIPTION,
  ALIGNMENT_WITH_STRETCH_DESCRIPTION,
  IMAGE_SIZE_DESCRIPTION,
  TOGGLE_DESCRIPTION,
  numberEnumMetadata,
  numberMetadata,
} from '../../../../../utils/builderMetadata'

export type LayoutStylesParams = {
  spaceBetweenExperiences: StyleParamType.Number
  maximumExperiencesPerRow: StyleParamType.Number
  titleAlignment: StyleParamType.Number
  experienceTextAlignment: StyleParamType.Number
  experienceButtonAlignment: StyleParamType.Number
  fitLocationTabsWidthToListWidth: StyleParamType.Number
  locationTabsAlignment: StyleParamType.Number
  experienceImageSize: StyleParamType.Number
}

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  spaceBetweenExperiences: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 20 : 32),
    metadata: numberMetadata(StyleType.gap, {defaultValue: 32, mobileDefaultValue: 20}),
  },
  maximumExperiencesPerRow: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 1 : 3),
    metadata: numberMetadata(
      StyleType.number,
      {defaultValue: 3, mobileDefaultValue: 1},
      'Maximum number of experience cards per row',
    ),
  },
  titleAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata({defaultValue: Alignment.Center}, ALIGNMENT_DESCRIPTION),
  },
  experienceTextAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata({defaultValue: Alignment.Center}, ALIGNMENT_DESCRIPTION),
  },
  experienceButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata(
      {defaultValue: Alignment.Center},
      ALIGNMENT_WITH_STRETCH_DESCRIPTION,
    ),
  },
  fitLocationTabsWidthToListWidth: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 1 : 0),
    metadata: numberEnumMetadata(
      {defaultValue: 0, mobileDefaultValue: 1},
      `Fit location tabs width to the list width: ${TOGGLE_DESCRIPTION}`,
    ),
  },
  locationTabsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata({defaultValue: Alignment.Center}, ALIGNMENT_DESCRIPTION),
  },
  experienceImageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageSize.Crop,
    metadata: numberEnumMetadata({defaultValue: ImageSize.Crop}, IMAGE_SIZE_DESCRIPTION),
  },
})
